module.exports = __webpack_public_path__ + "static/media/workprocess4.6b7f09a8.png";